export class CloneFactor {
  static readonly type = '[Contract.Factor] Clone Factor';
  constructor(public factorID: number, public copies: number = 1) {}
}

export class DeleteFactor {
  static readonly type = '[Contract.Factor] Delete Factor';
  constructor(public factorID: number) {}
}

export class RestoreFactor {
  static readonly type = '[Contract.Factor] Restore Factor';
  constructor(public factorID: number) {}
}

export class AddFactor {
  static readonly type = '[Contract.Factor] Add Factor';
  constructor(public lineID: string, public Factor: any) {}
}

export class UpdateFactor {
  static readonly type = '[Contract.Factor] Update Factor';
  constructor(public Factor: any) {}
}
